import { SEO } from '../components/SEO';
import { PortalLayout } from '../components/PortalLayout';
import { PortalSidebar } from '../components/PortalSidebar';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ScrollReveal } from '../components/ScrollReveal';
import { enforcementTimeline, rulesMeta } from '../data/rulesContent';
import { resourcesSidebarGroups } from '../data/resources';

const EnforcementTimeline = () => (
  <>
    <SEO
      title="DPDPA & DPDP Rules Enforcement Timeline"
      description="The phased enforcement timeline of the Digital Personal Data Protection Act and DPDP Rules, 2025 — from notification on 13 November 2025 to the full compliance deadline on 13 May 2027."
      path="/resources/enforcement-timeline"
    />
    <PortalLayout
      breadcrumb={<Breadcrumbs trail={[{ label: 'Resources', href: '/resources' }, { label: 'Enforcement Timeline' }]} />}
      sidebar={<PortalSidebar heading="Resources" headingHref="/resources" groups={resourcesSidebarGroups} activeItemId="enforcement-timeline" defaultOpenGroupId="resources" />}
    >
      <div data-testid="enforcement-timeline-page" className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-saffron-600 mb-3">Resources</p>
        <h1 className="font-serif text-3xl sm:text-4xl text-navy leading-tight mb-4">Enforcement Timeline</h1>
        <p className="text-gray-600 leading-relaxed mb-10">Notified by {rulesMeta.authority} on {rulesMeta.notified}, the DPDP Rules bring the Act into force in three phases.</p>
        <div data-testid="enforcement-timeline-section">
          {enforcementTimeline.map((m, i) => (
            <ScrollReveal key={m.date} delay={i * 0.1}>
              <div data-testid={`enforcement-timeline-item-${i}`} className="flex flex-col sm:flex-row gap-4 sm:gap-8 py-7 border-b border-gray-200">
                <p className="font-mono text-sm text-saffron-600 w-36 shrink-0">{m.date}</p>
                <div>
                  <p className="font-serif text-lg text-navy mb-2">{m.title}</p>
                  <p className="text-sm text-gray-500 leading-relaxed">{m.description}</p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </PortalLayout>
  </>
);

export default EnforcementTimeline;
